var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delete-coupon" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认删除",
            visible: _vm.dialogVisible,
            width: "50%",
            "destory-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticClass: "delete-coupon-content" }, [
            _c("i", { staticClass: "el-icon-question" }),
            _vm._v(" "),
            _c("p", [_vm._v("删除后数据不能被恢复，确认删除吗！")]),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "deager", loading: _vm.loading },
                  on: { click: _vm.submit },
                },
                [_vm._v("删除")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }